var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-3",attrs:{"fluid":""}},[(_vm.isDpjp)?[_c('DashboardDokter'),_c('TrenKunjunganDokter')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }